// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
import {
    //Card
    Card, CardHeader, CardContent, 
    //Buttons & chips
    Button, ButtonGroup, Chip, 
    //Layout
    Typography, Popover, Box, Grid, Dialog, 
    //Input
    TextField} from '@material-ui/core';
//import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';

import { DateRangePicker } from 'materialui-daterange-picker';

//import Chip from '@material-ui/core/Chip';
//import Popover from '@material-ui/core/Popover';
import moment from 'moment';
//Custom component imports
import Daysetting from '../daysettings/Daysetting';
import EventDatePicker from '../forms/EventDatePicker';
import dsutils from '../daysettings/Utils';
import Simulator from '../daysettings/Simulator';
import CalView from '../daysettings/Calendar';
//import { CallMissedSharp } from '@material-ui/icons';
const utils = dsutils();
//import withWidth from "@material-ui/core/withWidth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	dscard : {
		margin:5,
	},
    nameDescription: {
		display: "flex",
		flexGrow: 1,
		flexDirection: 'column'
	},
    discreetInput : {
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:hover':{
			backgroundColor:theme.palette.background.paper
		}
	},
    largeFont : {
		fontSize: '1.3em',
		fontWeight: 'bold'
	},
    speedInput : {
        width : 110,
        fontSize: '5em'
    },
    timeInput : {
        width : 150
    },
    assigned : {
        backgroundColor: theme.palette.primary.light,
        color : theme.palette.primary.contrastText,
    },
    calcontain : {
        maxWidth: 400
    },
    simcontain : {
        width : `calc(100% - 400)`,
    }
}));


export default function CalendarStandard(props) {
	const classes = useStyles();
	//inherited variables
  	const {id, sign, handleSend, config, loadedToken, onChange} = props;

    //the currently selected date
    const [curdate, setCurdate] = React.useState(moment().format('YYYY-MM-DD'));

    //master shutdown range open
    const [rangeOpen, setRangeOpen] = React.useState(false);

    //master shutdown date range
    const [dateRange, setDateRange] = React.useState({});

	const [cid, setCid] = React.useState(0);
	const [myConfig, setMyConfig] = React.useState({
		monday: 0,
		tuesday: 0,
		wednesday: 0,
		thursday: 0,
		friday: 0,
		saturday: 0,
		sunday: 0,
		special_events: [],
		daysettings: {
			0: Object.assign({}, utils.model.daysetting)
		},
        messages : [0, 0, 0, 0]
	});


	//Initialize event date picker popover
	const [datePop, setDatePop] = React.useState({
		anchor: null,
		open: false,
		date: null,
		id: 0
	});


    //Initialize weekday popover
    const [weekdayPopAnchor, setWeekdayPopAnchor] = React.useState(null);
	
	//Close event date popper
	const closePop = () => {
		setDatePop({
			anchor: null,
			open : false,
			date: null,
			id: 0
		});
	}

	//Update UI on props change
  	React.useEffect(() => {
	  //only do this when config changes
	  	if(config.id === 0 || 
		   config.id === '0' ||
		   config.id === null || 
		   config.id === undefined 
		   || config.id !== cid 
		  ){
			setCid(config.id);
			setMyConfig(config);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);


	//Click Add New Special Event
	const handleAddDaysetting = (e) => {
		let newConfig = Object.assign({}, myConfig);
		//let newDaysettings = Object.assign({}, daysettings);
		//let newMyEvents = Object.assign([], myEvents);
		let ndsid = Date.now();
		newConfig.daysettings[ndsid] = Object.assign({}, utils.model.daysetting);
		newConfig.daysettings[ndsid].id = ndsid;
		newConfig.special_events.unshift({
		//newMyEvents.push({
			date: curdate,
			day_settings: ndsid
		});
		handleChange(newConfig);
		//setMyConfig(newConfig);
		//setDaysettings(newDaysettings);
		//setMyEvents(newMyEvents);
	}
	
	//Click Add chip for event date
	const addEventDate = (e, daysetting) => {
		//opens the date picker popper
		setDatePop({
			anchor: e.currentTarget,
			open: true,
			date: new Date(),
			id: daysetting
		});
	}
	
	//handle add event date
	const handleAddEventDate = (eventDate, daysetting) => {
		//add the event date entry to the special events array
		let newConfig = Object.assign({}, myConfig);
		//check to see if that date already has a daysetting
		let idx = newConfig.special_events.findIndex((se) => {return se.date === eventDate});
		if(idx !== -1){
			//remove existing date
			newConfig.special_events.splice(idx, 0);
		}
		newConfig.special_events.push({
			date : eventDate,
			day_settings : daysetting
		});
		//setMyConfig(newConfig);
		handleChange(newConfig);
		closePop();
		
	}
	
	//click delte on an existing event date
	const handleDelEventDate = (eventDate, daysetting) => {
		//find the daysetting with that event date and delete it
		let idx = myConfig.special_events.findIndex((se) => { return se.date === eventDate && se.day_settings === daysetting});
		if(idx !== -1){
			let newConfig = Object.assign({}, myConfig);
			newConfig.special_events.splice(idx, 1);
			handleChange(newConfig);
			//setMyConfig(newConfig);
		}
	}
	
	//handle any changes to the configuration and update parent
	const handleChange = (newConfig) => {
        console.log(newConfig);
		setMyConfig(newConfig);
		if(onChange){
			onChange(newConfig);
		}
	}
	
	//handle daysetting changes
	const handleDaysettingChange = (dsid, daysetting) => {
		let newConfig = Object.assign({}, myConfig);
		myConfig.daysettings[dsid] = daysetting;
		handleChange(newConfig);
	}
	
	//compile human date/calendar
	const humanDate = utils.control.date.human;
   

    //add master shutdown clicked
    const handleAddMasterShutdown = (e) => {
        //console.log("master shutdown!");
        toggleRangeOpen();
    }

    //check if curdate is in master shutdown
    const isMasterShutdown = (checkDate) => {
        if(!myConfig.master_shutdown) return false;
        if(myConfig.master_shutdown.length === 0) return false;
        return myConfig.master_shutdown.findIndex(ms => ms.dateOff <= checkDate && ms.dateOn > checkDate) !== -1;
    }

    const thisMasterShutdown = (checkDate) => {
        if(!myConfig.master_shutdown) return false;
        return myConfig.master_shutdown.findIndex(ms => ms.dateOff <= checkDate && ms.dateOn > checkDate);
    }

    //get daysetting id of the provided date
    const getDateSetting = (date) => {
        if(isMasterShutdown(date)) return false;
        let sevent = myConfig.special_events.find(e => e.date === date);
        if(sevent) return sevent.day_settings;
        return myConfig[moment(date).format('dddd').toLowerCase()];
    }

    //todays daysetting
    const curdateSetting = getDateSetting(curdate);

    //remove weekday from daysetting
    const handleRemoveDay = (day, dsid) => {
        var newdsid = Date.now();
		console.log("New Daysetting");
		console.log(newdsid);
        var newConfig = Object.assign({}, myConfig, {[day] : newdsid});

		newConfig.daysettings[newdsid] = Object.assign({}, utils.model.daysetting);
		newConfig.daysettings[newdsid].id = newdsid;
        //setMyConfig(newConfig);
        //onChange(newConfig);
        handleChange(newConfig)
    }
    //open add weekday
    const addWeekday = (e) => {
        //console.log("open weekday selector");
        setWeekdayPopAnchor(e.currentTarget);
    }

    //compile the assigned weekdays
    const compileWeekdayChips = () => {
        //days it has
        var useddays = utils.model.days.filter(d => myConfig[d] === curdateSetting);
        var addChip = (<Chip label="Add" icon={<AddIcon />} color='primary' onClick={addWeekday} />)
        if(useddays.length === 7){
            addChip = '';
        }
        return (
            <div>
            <Typography variant='h5' component='h2'>
                    Weekdays
            </Typography>
            {useddays.map((day, i) => (
                    <Chip
                        key={i}
                        label={day.substring(0, 1).toUpperCase()+day.substring(1)}
                        onDelete={ e => handleRemoveDay(day, curdateSetting)}
                    />
                ))}
                {addChip}
            </div>
        )
    }

    //close the weekday popover
    const closeWeekdayPop = () => {
        setWeekdayPopAnchor(null);
    }



    //assign current daysetting to selected weekday
    const assignWeekday = (day) => {
        var newConfig = Object.assign({}, myConfig, {[day] : curdateSetting});
        handleChange(newConfig);
        //setMyConfig(newConfig);
        //onChange(newConfig);
    }

    //change name or description
    const handleChangeND = (e) => {
        //copy config
        var newConfig = Object.assign({}, myConfig);
        newConfig.daysettings[curdateSetting][e.target.name] = e.target.value;
        handleChange(newConfig);
    }

    //compile the daysetting display for the current date
    const compileThisDay = () => {
        if(!curdateSetting)
            return '';
        let days = utils.model.days.filter(d => myConfig[d] === curdateSetting);
        //let ucdays = days.map(d => d.substring(0, 1).toUpperCase()+d.substring(1));
		let name = myConfig.daysettings[curdateSetting].name;
		let description = myConfig.daysettings[curdateSetting].description;
		if(!name){
            if(days.length === 0){
                name = [humanDate(curdate), 'Event'].join(' ');
            } else {
                name = utils.control.setting.name(utils.model.days.filter(d => myConfig[d] === curdateSetting));
            }
		}
		if(!description){
			description = utils.control.setting.description(myConfig.daysettings[curdateSetting]);
		}
        return (
            <div>
            <CardContent>
                <Box className={classes.nameDescription}>
						<TextField
							id='daysetting_name'
							label=""
							name='name'
							value={name}
							InputProps={{
								disableUnderline:true,
								classes: {
									input: classes.largeFont
								}
							}}
							inputProps={{maxLength: 25}}
							className={classes.discreetInput}
							onChange={handleChangeND}
							size="medium"
							fullWidth
						/>
	  					<TextField
							id='daysetting_description'
							label=""
							name='description'
							className={classes.discreetInput}
							InputProps={{disableUnderline:true}}
							value={description}
							onChange={handleChangeND}
							size="small"
							fullWidth
						/>
				</Box>
                </CardContent>
                <Grid container>
                    <Grid item xs={12} md={3} lg={2} className={classes.assigned}>
                        <CardContent>
                    {compileWeekdayChips()}
                    {compileDateChips()}
                        </CardContent>
                    </Grid>
                    <Grid item xs={12} md={9} lg={10}>
                        <CardContent>
                    <Daysetting 
                        id={id} sign={sign} handleSend={handleSend} 
                        onChange={handleDaysettingChange} 
                        config={myConfig} dsid={curdateSetting} loadedToken={loadedToken} 
                    /> 
                    </CardContent>
                    </Grid>
                </Grid>
           
            </div>
        );
    }
	
	//Compile the date chips
	const compileDateChips = () =>{
        let events = myConfig.special_events.filter(e => e.day_settings === curdateSetting);
		return (
			<div>
				<Typography variant="h5" component="h2">
					Dates
				</Typography>
				{events.map((row, i) => (
					<Chip
				 		key={i}
						label={humanDate(row.date)}
						onDelete={(e) => {handleDelEventDate(row.date, row.day_settings)}}
					/>
				))}
				<Chip label="Add" icon={<AddIcon />} color='primary' onClick={(e) => {addEventDate(e, curdateSetting)}} /> 
			</div>
			
		);
	};

    const toggleRangeOpen = () => {
		//handleUpdateRange();
		setRangeOpen(!rangeOpen);
	}

    const addMSRange = (e) => {
        let ndr = {
            dateOn: moment(dateRange.endDate).format('YYYY-MM-DD'),
            dateOff: moment(dateRange.startDate).format('YYYY-MM-DD'),
            config_id: myConfig.id
        }
        let newConfig = Object.assign({}, myConfig);
        newConfig.master_shutdown.push(ndr);
        handleChange(newConfig);
        console.log('saved', dateRange, ndr);
        setDateRange({});
        toggleRangeOpen();
    }

    const renderSaveRange = () => {
        //console.log(dateRange);
        if(!dateRange.startDate) return '';
        if(!dateRange.endDate) return '';

        return (<Button variant='contained' fullWidth color='primary' onClick={addMSRange}>Apply</Button>);
    }

    //const curms = curdateSetting ? false : thisMasterShutdown(curdate);

    const compileThisShutdown = () => {
        let curms = thisMasterShutdown(curdate);
        if(curms === false) return '';
        let ms = myConfig.master_shutdown[curms];
        return(
            <Box display='flex' justifyContent='space-around' alignItems='center'>
                <Typography>Sign is off from {humanDate(ms.dateOff)} until {humanDate(ms.dateOn)}</Typography>
                <Button color='primary' variant='contained' onClick={e => removeMS(curms)}>Remove Shutoff Period</Button>
            </Box>
        )
    }

    const removeMS = (ms) => {
        //copy config
        let newConfig = Object.assign({}, myConfig);
        newConfig.master_shutdown.splice(ms, 1);
        handleChange(newConfig);
    }

    const simUI = (
        <Box>
        <ButtonGroup fullWidth>
            <Button variant="contained" disabled={!curdateSetting} color="primary" startIcon={<AddIcon />} onClick={handleAddDaysetting}>
				New Day Schedule
			</Button>
            <Button variant='contained' color='primary' startIcon={<AddIcon />} onClick={handleAddMasterShutdown}>
                Add Shutoff Period
            </Button>
            </ButtonGroup>
            <Card>
                <CardHeader title={humanDate(curdate)} />
                <CardContent>
                    {curdateSetting ? 
                    <Simulator sign={sign} config={myConfig} date={curdate} /> :
                    compileThisShutdown()
                    }
                    
                </CardContent>
            </Card>
        </Box>
    );

    const popdiags = [
            //Event Date Selector
            (<Popover
                    key={1}
					id='eventDatePopper'
					open={datePop.open}
					anchorEl={datePop.anchor}
					onClose={closePop}
					anchorOrigin={{ vertical:'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical:'top', horizontal:'center'}}
				>
				<EventDatePicker date={datePop.date} label="Event Date" daysetting={datePop.id} onChange={handleAddEventDate} />
			</Popover>),
            //Weekday Selector
            (
            <Popover
                id='weekdayPopover'
                key={2}
                open={Boolean(weekdayPopAnchor)}
                anchorEl={weekdayPopAnchor}
                onClose={closeWeekdayPop}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                transformOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <ButtonGroup orientation='vertical'>
                {utils.model.days.filter(d => myConfig[d] !== curdateSetting).map((day, i) => (
                    <Button onClick={e => assignWeekday(day)} variant='contained'>{day.substring(0, 1).toUpperCase()+day.substring(1)}</Button>
                ))}
                </ButtonGroup>
            </Popover>
            ),
            //Master Shutdown Date Range picker
            (
            <Dialog key={3} open={rangeOpen}>
				<DateRangePicker
					open={rangeOpen}
					toggle={toggleRangeOpen}
					onChange={(range) => setDateRange(range)}
					initialDateRange={dateRange}
					definedRanges={[]}
				/>
				{renderSaveRange()}
			</Dialog>
            )

    ]

 

	
  	return (
    	<Grid container className={classes.root} spacing={2}>
            <Grid item xs={12} md={12} lg>
                {simUI}
            </Grid>
            <Grid item xs={12} md={12} lg='auto'>
                <CalView config={myConfig} date={curdate} onChange={setCurdate} />
            </Grid>
            <Grid item xs={12}>
            <Card>{compileThisDay()}</Card>
            </Grid>
			{popdiags}
    	</Grid>
  	);
}
